import {    APPLICATION_UPDATE_DATA,
            APPLICATION_SAVED_DATA_SUCCESS,            
            RECEIVE_APPLICATION_SUCCESS,
            APPLICATION_SAVING_DATA,
            REGISTRATION_SAVING_DATA,
            REGISTRATION_SAVED_DATA_SUCCESS,
            REQUEST_UPDATE_APPLICATION_STATUS,
            RECEIVE_UPDATE_APPLICATION_STATUS,
            RECEIVE_UPDATE_APPLICATION_STATUS_ERROR,
            REQUEST_UPDATE_LOANPARAMETERS,
            RECEIVE_UPDATE_LOANPARAMETERS,
            RECEIVE_UPDATE_LOANPARAMETERS_ERROR,
            REQUEST_APPLICATION_DETAILS,
            RECEIVE_APPLICATION_DETAILS_SUCCESS,
            RECEIVE_APPLICATION_DETAILS_ERROR,

            REQUEST_UPDATE_ADM_APPLICATION,
            RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS,

            REQUEST_ASIAKASTIETO,
            RECEIVE_ASIAKASTIETO,
            RECEIVE_ASIAKASTIETO_ERROR,
            REQUEST_APPLICATION_DESCRIPTION,
            RECEIVE_APPLICATION_DESCRIPTION_SUCCESS,
            RECEIVE_APPLICATION_DESCRIPTION_ERROR,
            RECEIVE_MARKLOANDISBURSED_SUCCESS,
            REQUEST_MARKLOANDISBURSED,
            REQUEST_VALIDATE_EMAIL, 
            RECEIVE_VALIDATE_EMAIL,
            RECEIVE_VALIDATE_EMAIL_ERROR,
            REQUEST_LOAN,
            REQUEST_LOAN_SUCCESS,
            REQUEST_LOAN_ERROR,
            REQUEST_VALIDATE_PHONE,
            RECEIVE_VALIDATE_PHONE,
            RECEIVE_VALIDATE_PHONE_ERROR,
            REQUEST_VALIDATE_EMAIL_CODE, 
            RECEIVE_VALIDATE_EMAIL_CODE,
            RECEIVE_VALIDATE_EMAIL_ERROR_CODE,
            REQUEST_VALIDATE_PHONE_CODE,
            RECEIVE_VALIDATE_PHONE_CODE,
            RECEIVE_VALIDATE_PHONE_ERROR_CODE,
            REQUEST_GET_ATTACHMENTS,
            RECEIVE_GET_ATTACHMENTS_SUCCESS,
            RECEIVE_GET_ATTACHMENTS_ERROR

        }  from '../actions/application'




const DEFAULT_APPLICATION_STATE =   {
    isFetching: false,
    email: '',
    lastName: '',
    firstName: '',
    bic: '',
    companyName: '',
    companySsnBic: '',
    tel: '',
    gender: '',
    password: '',
    country: '1',
    language: 'Suomi',
    savedToCloud: false,
    termsAndUsage:true,
    isCompany:true ,
    addressCo: '',
    address: '',
    zip: '',
    city: '',
    businessLine: '',
    contactDetails: '',
    isPrhFetched: false,
    isEmailValidationRequested: false,
    isEmailValidated: false,
    isPhoneValidated: false
    };

export function attachments(state = {isFetching: false, data: []}, action) {
    switch (action.type) {
        case REQUEST_GET_ATTACHMENTS: {        
            console.log("Reducer: REQUEST_GET_ATTACHMENTS");
            return {...state, isFetching: true}
        } 
        case RECEIVE_GET_ATTACHMENTS_SUCCESS: {        
            console.log("Reducer: RECEIVE_GET_ATTACHMENTS_SUCCESS", action.data);
            const attachmentsData = action.data.attachments || action.data;
            console.log("Processed attachments data:", attachmentsData);
            return {
                ...state,
                data: attachmentsData,
                isFetching: false
            }
        } 
        case RECEIVE_GET_ATTACHMENTS_ERROR: {        
            console.log("Reducer: RECEIVE_GET_ATTACHMENTS_ERROR", action.error);
            return {
                ...state,
                error: action.error,
                isFetching: false
            }
        } 
        default: {
            return state;
        }
    }
}

export function applicationDetails(state = {isFetching:true}, action) {
    switch (action.type) {
        case REQUEST_APPLICATION_DETAILS: {        
            return {...state, isFetching:true}
        } 
        case RECEIVE_APPLICATION_DETAILS_SUCCESS: {        
            var newstate = {...action.application, isFetching:false}
            return newstate;
        } 
        default: {
            return state;
        }
    }
}

export function applicationDescription(state = {isFetching:true}, action) {
    switch (action.type) {
        case REQUEST_APPLICATION_DESCRIPTION: {        
            return {...state, isFetching:true}
        } 
        case RECEIVE_APPLICATION_DESCRIPTION_SUCCESS: {        
            var newstate = {...action.application, isFetching:false}
            return newstate;
        } 
        default: {
            return state;
        }
    }
}


export function application(state = DEFAULT_APPLICATION_STATE, action) {    
    switch (action.type) {


        case 'APPLICANT_CREATE_SUCCESS': {        
            return action.applicant;
        }
        case RECEIVE_UPDATE_APPLICATION_STATUS:
        {
            var newstate = {
                ...state,                
                ...action.data,
                isFetching: false
                 }
               
            return newstate;
        }

        case REQUEST_UPDATE_APPLICATION_STATUS:
        {
            var newstate = {
                ...state,                
                isFetching: true
                 }
               
            return newstate;
        }

        case  REQUEST_UPDATE_ADM_APPLICATION:

        {
            var newstate = {
                ...state,                
                isFetching: true
                 }
               
            return newstate;
        }

        case REQUEST_ASIAKASTIETO:
        {
            var newstate = {
                ...state,                
                isFetching: true
                 }
               
            return newstate;
        }

        case RECEIVE_ASIAKASTIETO:
        {
            var newstate = {
                ...state,                
                ...action.riskdata,
                isFetching: false,
 
            }
               
            return newstate;
        }
        

        case RECEIVE_UPDATE_LOANPARAMETERS:
        {
            var newstate = {
                ...state,                
                ...action.data,
                isFetching: false
                 }
               
            return newstate;
        }

        case REQUEST_UPDATE_LOANPARAMETERS:
        {
            var newstate = {
                ...state,                
                isFetching: true
                 }
               
            return newstate;
        }


        case APPLICATION_UPDATE_DATA:
        {
            
            var newstate = {
                ...state,                
                ...action.application
                 }
               
            return newstate;
        }
        case RECEIVE_APPLICATION_SUCCESS: {
            var newstate = {
                ...state,                                
                isFetching: false
                 }
            return newstate;  
        }
        case APPLICATION_SAVING_DATA: {
            return {...state, isFetching: true};
        }        

        case APPLICATION_SAVED_DATA_SUCCESS:
        {
            var newstate = {
                ...state,                
                ...action.data,
                isFetching: false
                 }
            return newstate;
        }

        case REGISTRATION_SAVING_DATA: {
            return {...state, isFetching: true};
        }        
        
        case REGISTRATION_SAVED_DATA_SUCCESS:
        {
            var newstate = {
                ...state,                
                ...action.data,
                isFetching: false
                 }
            return newstate;
        }


        case RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS:
        {
            var newstate = {
                ...state,                
                ...action.application,
                isFetching: false
                 }
            return newstate;
        }

        case REQUEST_VALIDATE_EMAIL: {
            var newstate = {
                ...state,                
                ...action.application,
                isEmailValidationRequested: true
                 }
            return newstate;            
        }

        case REQUEST_VALIDATE_PHONE: {
            var newstate = {
                ...state,                
                ...action.application,
                isPhoneValidationRequested: true
                 }
            return newstate;            
        }

        case REQUEST_VALIDATE_EMAIL_CODE: {
            var act = action;
            var newstate = {
                ...state, 
                isEmailValidationCodeRequested: true,
                isEmailValidated: false  

                 }
            return newstate;            
        }
        case RECEIVE_VALIDATE_EMAIL_CODE: {
            var newstate = {
                ...state, 
                isEmailValidated: action.data.validationResult,
                isEmailValidationCodeRequested: false,
 
                 }
            return newstate;            
        }
 
        case REQUEST_VALIDATE_PHONE_CODE: {
            var act = action;
            var newstate = {
                ...state, 
                isPhoneValidationRequested: true,
                isPhoneValidated: false  
                 }
            return newstate;            
        }
        case RECEIVE_VALIDATE_PHONE_CODE: {
            var newstate = {
                ...state, 
                isPhoneValidated: action.data.validationResult,
                isPhoneValidationCodeRequested: false, 
                 }
            return newstate;            
        }

        case RECEIVE_VALIDATE_EMAIL: {
            var newstate = {
                ...state,                
                ...action.application,
                isEmailValidationRequested: true
                 }
            return newstate;            
        }

        case RECEIVE_VALIDATE_PHONE: {
            var newstate = {
                ...state,                
                ...action.application,
                isPhoneValidationRequested: true
                 }
            return newstate;            
        }


        case 'YTJ_FAILURE': {
            
            return state;
        }

        case 'YTJ_SUCCESS': {
            
            console.log('YTJ_SUCCESS', action.data);

            let applicant = Object.assign({}, state);
            
            if( action.data.companies && action.data.companies.length > 0) {
                const company = action.data.companies[0];
                
                // Get the company name (type "1", version 1 - prioritize active, but accept ceased companies)
                const currentName = company.names && (
                    // First try to find an active name with type "1" and version 1 (no endDate or future endDate)
                    company.names.find(name => 
                        name.type === "1" && name.version === 1 && (!name.endDate || new Date(name.endDate) > new Date())
                    ) ||
                    // If no active name with version 1, try any active name with type "1"
                    company.names.find(name => 
                        name.type === "1" && (!name.endDate || new Date(name.endDate) > new Date())
                    ) ||
                    // If no active name, get the most recent name with type "1" and version 1
                    company.names
                        .filter(name => name.type === "1" && name.version === 1)
                        .sort((a, b) => new Date(b.registrationDate) - new Date(a.registrationDate))[0] ||
                    // If no name with version 1, get the most recent name with type "1"
                    company.names
                        .filter(name => name.type === "1")
                        .sort((a, b) => new Date(b.registrationDate) - new Date(a.registrationDate))[0]
                );
                
                if (currentName) {
                    applicant.companyName = currentName.name;
                    
                    // Set business ID
                    if (company.businessId && company.businessId.value) {
                        applicant.companySsnBic = company.businessId.value;
                    }

                    // Set business line from mainBusinessLine (Finnish description - languageCode "1")
                    if (company.mainBusinessLine && company.mainBusinessLine.descriptions) {
                        const finnishDescription = company.mainBusinessLine.descriptions.find(desc => 
                            desc.languageCode === "1"
                        );
                        if (finnishDescription) {
                            applicant.businessLine = finnishDescription.description;
                        }
                    }

                    // Set address (type 1, active addresses without endDate)
                    console.log('company.addresses', company.addresses);
                    if (company.addresses && company.addresses.length > 0) {
                        let address = company.addresses.filter(el => 
                            el.type === 1 && !el.endDate
                        );

                        console.log('address to use', address);
                        if (address && address[0]) {
                            const addr = address[0];
                            applicant.addressCo = addr.co || '';
                            applicant.address = addr.street || '';
                            applicant.address = (applicant.address + ' ' + (addr.buildingNumber || '')).trim();
                            applicant.address = (applicant.address + ' ' + (addr.apartmentNumber || '')).trim();
                            applicant.address = (applicant.address + ' ' + (addr.entrance || '')).trim();
                            //trim address
                            applicant.address = applicant.address.trim();
                            applicant.zip = addr.postCode || '';
                            
                            // Get city from postoffices with languageCode "1"
                            if (addr.postOffices && addr.postOffices.length > 0) {
                                const finnishPostoffice = addr.postOffices.find(po => 
                                    po.languageCode === "1"
                                );
                                if (finnishPostoffice) {
                                    applicant.city = finnishPostoffice.city || '';
                                }
                            }
                        }
                    }
                    
                    // Contact details (may not exist in new format)
                    if (company.contactDetails && company.contactDetails.length > 0) {
                        applicant.contactDetails = company.contactDetails[0].value;
                    }
                    
                    applicant.isPrhFetched = true;                

                    var newstate = {
                        ...state,                
                        ...applicant
                    }

                    return Object.assign({}, state, newstate);
                }
            }
            return state;
        }

        
        default: {
            return state;
        }
    }
}
